/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
/*------------------------------------*\
    Calendat
\*------------------------------------*/
class RacingCalendar {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.selector = document.querySelector("#selector");

        // Fetch the marker data
        fetch("/api/races.json")
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                self.createCalendar(json);
            })
            .catch(function (ex) {
                console.log("Parsing failed", ex);
            });
    }

    createCalendar(json) {

        let self = this;

        self.renderCalendar(json, '')

        self.selector.addEventListener("change", function () {

            /** */
            var goToDate = self.calendar.getDate()
            self.renderCalendar(json,  goToDate)

        });
  
    }

    renderCalendar(json, gotoDate){
        let self = this;

            /** Duplication start */
            self.calendarRacesArray = json.data;


            var calendarEl = self.elem;

            var calendar = new FullCalendar.Calendar(calendarEl, {

                events: self.calendarRacesArray,

                showNonCurrentDates: false,




                eventTextColor: '#333333',

                initialView: "dayGridMonth",

                firstDay: 1, // Set the first day of the week to Monday

                headerToolbar: {
                    left: "",
                    right: ''
                  },
    
                eventDidMount: function (info) {




                    var eventElement = info.el;
                    let descriptionElement = document.createElement("p");
    


                    descriptionElement.classList.add("racing-calendar__text");
                    descriptionElement.classList.add("racing-calendar__text--desc");

                    

                    

                    descriptionElement.innerHTML = info.event.extendedProps.description;

                    eventElement.appendChild(descriptionElement);
                    
                    if(!(info.event.extendedProps.website == '')){
                        let websiteLink = document.createElement("a");

                        websiteLink.setAttribute("target", "_blank");

                        websiteLink.classList.add("racing-calendar__text");
                        websiteLink.classList.add("racing-calendar__text--link");
                        websiteLink.href = info.event.extendedProps.website;
                        websiteLink.textContent = "Visit Website";
                        eventElement.appendChild(websiteLink);
                    }
    
                    let val = self.selector.value;
                    if (!(val == info.event.extendedProps.raceType || val == "all")) {
                        info.el.style.display = "none";
                    }
    
    
                },
                eventContent: function( info ) {
                    return {html: info.event.title};
                }
            });

            /** */
            if(!(gotoDate == '')){
                calendar.gotoDate( gotoDate )
            }

            /** */


            self.showMonth(calendar);

            document.getElementById('next-button').addEventListener('click', function() {
                calendar.next();
                self.showMonth(calendar);
              });
            document.getElementById('prev-button').addEventListener('click', function() {
                calendar.prev();
                self.showMonth(calendar);
            });

              

            calendar.render();
            self.calendar = calendar;

    }
    showMonth(calendar){
        let self = this;


        var currentDate =calendar.getDate();
        var formattedDate = calendar.formatDate(currentDate, {
            month: 'long',
            year: 'numeric',
        });
        // Find the HTML element with id 'calendar-title'
        var calendarTitleElement = document.getElementById('calendar-title');

        // Check if the element exists before updating its content
        if (calendarTitleElement) {
            // Set the content of the element to the formatted date
            var month = formattedDate.split(' ')[0]
            var year = formattedDate.split(' ')[1]


            calendarTitleElement.innerHTML = month + ' <span class="text-primary">'+ year +'</span>';
        } else {
            console.error("Element with id 'calendar-title' not found.");
        }


    }
}

export default RacingCalendar;
